import { ICommit } from "@/apps/merchant3/shared-models/ICommit";
import { SaleState } from "@/apps/merchant3/store/sale/mutations";

const actions = {
  setSaleState: ({ commit }: ICommit, payload: Partial<SaleState>): void => {
    commit("SET_SALE_STATE", payload);
  },
};

export default actions;
